import { DisplaySettingsState } from './display-settings-selectors';

import { Action } from './utils/state-manager';
import { JOB_STATUSES } from '../util/job-status';

export const DefaultCalendarEventFilters: SelectOption<string>[] = [
  { value: 'INTERVIEW', label: 'Interviews', selected: true },
  { value: 'NEW_EMPLOYEE_START', label: 'New Employee Starts', selected: true },
  { value: 'START_DATE', label: 'Automated Communications', selected: true },
  { value: 'BIRTHDATE', label: 'Birthdays', selected: true },
  { value: 'APPLICANT_REACH_OUT', label: 'Saved Applicant Reminder', selected: true },
];

export const DefaultJobStatusFilters: SelectOption<JobStatus>[] = [
  { value: JOB_STATUSES.PUBLISHED, label: 'Advertising', selected: true },
  { value: JOB_STATUSES.ACTIVE, label: 'Hiring', selected: true },
  { value: JOB_STATUSES.CLOSED, label: 'Inactive', selected: true },
  { value: JOB_STATUSES.ARCHIVED, label: 'Archived', selected: false },
];

// InitialState values won't work for any user specific display settings,
// Ideally, we create a persisted preference store, but for now we can return a default value
// in the selector if no current setting is found for the user
export const InitialState: DisplaySettingsState = {
  isInterviewSchedulePromptEnabled: true,
  jobLocationFilters: [],
  jobStatusFilters: DefaultJobStatusFilters,
  lastVisitedOrgId: null,
  hasDismissedQuickbooksAnnouncement: false,
  hasDismissedImportEmployeeListMessage: false,
  hideDisabledCalendarEvents: false,
  calendarEventFilters: DefaultCalendarEventFilters,
};

export default (state = InitialState, action: Action) => {
  switch (action.type) {
    case 'CHANGE_INTERVIEW_SCHEDULE_PROMPT': {
      const { isInterviewSchedulePromptEnabled } = action.payload;
      return { ...state, isInterviewSchedulePromptEnabled };
    }
    case 'UPDATE_JOB_LOCATION_FILTERS': {
      const { jobLocationFilters, username } = action.payload;
      return { ...state, [`jobLocationFilters-${username}`]: jobLocationFilters };
    }
    case 'UPDATE_JOB_STATUS_FILTERS': {
      const { jobStatusFilters, username } = action.payload;
      return { ...state, [`jobStatusFilters-${username}`]: jobStatusFilters };
    }
    case 'UPDATE_SHOW_ALL_JOBS': {
      const { showAllJobs, username } = action.payload;
      return { ...state, [`showAllJobs-${username}`]: showAllJobs };
    }
    case 'UPDATE_LAST_VISITED_ORG_ID': {
      const { orgId, username } = action.payload;
      return { ...state, [`lastVisitedOrgId-${username}`]: orgId };
    }
    case 'UPDATE_HAS_DISMISSED_QUICKBOOKS_ANNOUNCEMENT': {
      const { username, dismissed } = action.payload;
      return { ...state, [`hasDismissedQuickbooksAnnouncement-${username}`]: dismissed };
    }
    case 'UPDATE_HAS_DISMISSED_IMPORT_EMPLOYEE_LIST_MESSAGE': {
      const { username, dismissed } = action.payload;
      return { ...state, [`hasDismissedImportEmployeeListMessage-${username}`]: dismissed };
    }
    case 'UPDATE_CALENDAR_EVENT_FILTERS': {
      const { username, calendarEventFilters } = action.payload;
      return { ...state, [`calendarEventFilters-${username}`]: calendarEventFilters };
    }
    case 'UPDATE_HIDE_CALENDAR_DISABLED_EVENTS': {
      const { username, hideDisabledCalendarEvents } = action.payload;
      return { ...state, [`hideCalendarDisabledEvents-${username}`]: hideDisabledCalendarEvents };
    }
    default:
      return state;
  }
};
